import { flightProps, flightSearchProps } from "src/interfaces";
import { fetch } from "./http";
import { setTempModel, store } from "src/store";
import { createMailTemplate } from "src/helpers";
import { sendMail } from "./additional.services";
import axios from "axios";

import { json } from "stream/consumers";
const ameduesBaseUrl = process.env.REACT_APP_BASE_URL + "/";

const controller: string = "v2/shopping/";

export const fetchFlightOffersByGet = async (
  payload: flightSearchProps,
  token: string
) => {
  try {
    const url =
      controller +
      `flight-offers?originLocationCode=${payload?.origin}` +
      `&destinationLocationCode=${payload?.destination}` +
      `&departureDate=${payload?.departureDate}` +
      `${payload?.returnDate ? "&returnDate=" + payload?.returnDate : ""}` +
      `&adults=${payload?.adults}` +
      `&children=${payload?.children || 0}` +
      `&infants=${payload?.infants || 0}` +
      `&travelClass=${payload?.travelClass}` +
      `&nonStop=${payload?.nonStop || false}` +
      `&currencyCode=${payload?.currencyCode || "CAD"}` +
      `${payload?.max ? "&max=" + payload?.max : ""}`;

    // ✅ Debug logs (helpful during development)
    console.log("📡 Fetching flight offers from:", url);
    console.log("💱 Currency Code Used:", payload?.currencyCode || "CAD");

    const response = await fetch.Get(url, token);

    if (response.status === 200) {
      const data = await response.json();
      return data;
    } else if (response.status === 201) {
      const data = await response.json();
      throw new Error(data);
    } else if (response?.status !== 429 && response?.status !== 401) {
      throw new Error("Something went wrong");
    }
  } catch (error) {
    console.error("❌ fetchFlightOffersByGet error:", error);
    throw error;
  }
};

export const fetchFlightOffersPrices = async (payload: any) => {
  try {
    const finalPayload = {
      data: {
        type: "flight-offers-pricing",
        flightOffers: [payload],
      },
    };

    const token = store?.getState()?.auth?.access_token;

    const amaClientRef = store?.getState()?.amaClientRef?.clientRef || "";
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.BACKEND_URL}amadeus/proxy`,
      headers: {
        "Content-Type": "application/vnd.amadeus+json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        url: `${ameduesBaseUrl}/v1/shopping/flight-offers/pricing`,
        body: { ...finalPayload },
        ama_client_ref: amaClientRef,
        access_token: token,
      },
    };

    return await axios
      .request(config)
      .then((response) => {
        if (response.data) {
          return response?.data?.result?.data?.flightOffers[0];
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // return await axios
    //   .post(
    //     "https://test.travel.api.amadeus.com/v1/shopping/flight-offers/pricing",
    //     finalPayload,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${token}`,
    //         "Content-Type": "application/vnd.amadeus+json",
    //       },
    //     }
    //   )
    //   .then((response: any) => {
    //     console.log("response:: ", response);
    //   })
    //   .catch((error: any) => {
    //     console.log("error: ", error);
    //   });
    // if (response.status === 200) {
    //   const data = response;
    //   return data;
    // } else if (response.status === 201) {
    //   const data = response;
    // } else if (response?.status != 429 && response?.status != 401) {
    //   throw new Error("Something went wrong");
    // }
  } catch (error) {
    throw error;
  }
};

export const fetchFlightOffersByPost = async (
  payload: flightSearchProps,
  token: string
) => {
  const tempModel = store?.getState()?.tempModel;
  try {
    let travelers = [];
    let i = 1;
    for (i; i <= payload?.adults; i++) {
      travelers.push({
        id: i.toString(),
        travelerType: "ADULT",
      });
    }
    for (let j = 1; j <= payload?.children; j++) {
      travelers.push({
        id: i.toString(),
        travelerType: "CHILD",
      });
      i++;
    }
    for (let k = 1; k <= payload?.infants; k++) {
      travelers.push({
        id: i.toString(),
        associatedAdultId: k.toString(),
        travelerType: "HELD_INFANT",
      });
      i++;
    }

    const originDestinations: any[] = [
      {
        id: "1",
        originLocationCode: payload?.origin,
        destinationLocationCode: payload?.destination,
        departureDateTimeRange: {
          date: payload?.departureDate,
        },
      },
    ];
    if (payload?.returnDate && payload?.type == "round") {
      originDestinations?.push({
        id: "2",
        originLocationCode: payload?.destination,
        destinationLocationCode: payload?.origin,
        arrivalDateTimeRange: {
          date: payload?.returnDate,
        },
      });
    }
    let carrierRestrictions = {};
    console.log(payload?.source, "sjdhskjhdshdsklhdkslhdskjhdkjs");
    {
      if (payload?.includedCarrierCodes?.length > 0) {
        carrierRestrictions = {
          carrierRestrictions: {
            includedCarrierCodes: payload?.includedCarrierCodes,
          },
        };
      }
    }
  const finalPayload = {
    currencyCode: payload?.currencyCode || "CAD",
    originDestinations: originDestinations,
    travelers: travelers,
    sources: payload?.source,
    searchCriteria: {
      maxFlightOffers: payload?.max || 250,
      allowAlternativeFareOptions: true,

      maxPrice: payload?.maxPrice,
      pricingOptions: {
        fareType: ["PUBLISHED"],
        includedCheckedBagsOnly: false,
        includedCheckedBags: false,
      },
      flightFilters: {
        maxFlightTime: payload?.maxFlightTime,
        connectionRestriction: {
          maxNumberOfConnections: payload?.nonStop
            ? 0
            : payload?.maxNumberOfConnections,
          nonStopPreferred: payload?.nonStop,
        },
        ...carrierRestrictions,
        cabinRestrictions: [
          {
            cabin: payload?.travelClass,
            originDestinationIds: originDestinations?.map((item) => item?.id),
            coverage: "ALL_SEGMENTS",
          },
        ],
      },
      additionalInformation: {
        brandedFares: true,
        chargeableCheckedBags: false, 
        fareRules: true,
      },
    },
  };
 

    // ✅ Pretty log for full payload inspection
    console.log("🧾 Final Payload Sent to API:");
    console.log(JSON.stringify(finalPayload, null, 2), "Final Payload");
    const amaClientRef = store?.getState()?.amaClientRef?.clientRef || "";
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${process.env.BACKEND_URL}amadeus/proxy`,
      headers: {
        "Content-Type": "application/vnd.amadeus+json",
        Authorization: `Bearer ${token}`,
      },
      data: {
        url: `${ameduesBaseUrl}${controller}flight-offers`,
        body: finalPayload,
        ama_client_ref: amaClientRef,
        access_token: token,
      },
    };
    return await axios
      .request(config)
      .then((response) => {
        if (response.status === 200 && response.data?.status === true) {
          const data = response.data.result;
          return data;
        } else if (response?.status != 429 && response?.status != 401) {
          throw new Error("Something went wrong");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    // const response = await fetch.Post(
    //   controller + "flight-offers",
    //   finalPayload,
    //   "application/json",
    //   token
    // );
  } catch (error) {
    throw error;
  } finally {
    // store?.dispatch(setTempModel({ ...tempModel, searching: false }));
  }
};

export const fetchDealFlights = async (payload: any = {}, token: string) => {
  try {
    const data: flightProps = await fetchFlightOffersByGet(payload, token);
    const price = data?.data?.map((item) => item?.price?.grandTotal);
    return price[0];
  } catch (error) {
    throw error;
  }
};

export const createOrder = async (payload: any, token: string) => {
  try {
    let travelers = [];
    let i = 1;
    const searchModel = store?.getState()?.searchModel;
    const travelerPayload = payload?.billingDetailModel;
    for (i; i <= searchModel?.adults; i++) {
      const travelerType = "adults";
      travelers.push({
        id: i.toString(),
        type: travelerType,
        dateOfBirth: travelerPayload[`${travelerType}dob${i}`],
        name: {
          firstName: travelerPayload[`${travelerType}FirstName${i}`],
          middleName: travelerPayload[`${travelerType}MiddleName${i}`],
          lastName: travelerPayload[`${travelerType}LastName${i}`],
        },
        gender: travelerPayload[`${travelerType}Gender${i}`],
        contact: {
          addresseeName: {
            firstName: travelerPayload[`${travelerType}FirstName${i}`],
            middleName: travelerPayload[`${travelerType}MiddleName${i}`],
            lastName: travelerPayload[`${travelerType}LastName${i}`],
          },
          address: {
            lines: [travelerPayload["address"]],
            countryCode: travelerPayload["countryCode"],
            cityName: travelerPayload["cityName"],
            stateName: travelerPayload["stateName"],
            postalCode: travelerPayload["pinCode"],
          },
          emailAddress: travelerPayload?.email,
          phones: [
            {
              deviceType: "MOBILE",
              countryCallingCode: "91",
              number: travelerPayload?.phoneNumber,
            },
          ],
        },
      });
    }
    for (let j = 1; j <= searchModel?.children; j++) {
      const travelerType = "children";
      travelers.push({
        id: i.toString(),
        type: travelerType,
        dateOfBirth: travelerPayload[`${travelerType}dob${j}`],
        name: {
          firstName: travelerPayload[`${travelerType}FirstName${j}`],
          middleName: travelerPayload[`${travelerType}MiddleName${j}`],
          lastName: travelerPayload[`${travelerType}LastName${j}`],
        },
        gender: travelerPayload[`${travelerType}Gender${j}`],
        contact: {
          addresseeName: {
            firstName: travelerPayload[`${travelerType}FirstName${j}`],
            middleName: travelerPayload[`${travelerType}MiddleName${j}`],
            lastName: travelerPayload[`${travelerType}LastName${j}`],
          },
          address: {
            lines: [travelerPayload["address"]],
            countryCode: travelerPayload["countryCode"],
            cityName: travelerPayload["cityName"],
            stateName: travelerPayload["stateName"],
            postalCode: travelerPayload["pinCode"],
          },
          emailAddress: travelerPayload?.email,
          phones: [
            {
              deviceType: "MOBILE",
              countryCallingCode: "91",
              number: travelerPayload?.phoneNumber,
            },
          ],
        },
      });
      i++;
    }
    for (let k = 1; k <= searchModel?.infants; k++) {
      const travelerType = "infants";
      travelers.push({
        id: i.toString(),
        type: travelerType,
        dateOfBirth: travelerPayload[`${travelerType}dob${k}`],
        name: {
          firstName: travelerPayload[`${travelerType}FirstName${k}`],
          middleName: travelerPayload[`${travelerType}MiddleName${k}`],
          lastName: travelerPayload[`${travelerType}LastName${k}`],
        },
        gender: travelerPayload[`${travelerType}Gender${k}`],
        contact: {
          addresseeName: {
            firstName: travelerPayload[`${travelerType}FirstName${k}`],
            middleName: travelerPayload[`${travelerType}MiddleName${k}`],
            lastName: travelerPayload[`${travelerType}LastName${k}`],
          },
          address: {
            lines: [travelerPayload["address"]],
            countryCode: travelerPayload["countryCode"],
            cityName: travelerPayload["cityName"],
            stateName: travelerPayload["stateName"],
            postalCode: travelerPayload["pinCode"],
          },
          emailAddress: travelerPayload?.email,
          phones: [
            {
              deviceType: "MOBILE",
              countryCallingCode: "91",
              number: travelerPayload?.phoneNumber,
            },
          ],
        },
      });
      i++;
    }
    const finalPayload = { data: { ...payload?.data, travelers } };
    console.log(
      finalPayload,
      "finalPayloadfinalPayloadfinalPayloadfinalPayloadfinalPayloadfinalPayload"
    );

    const mailBody = createMailTemplate(travelers, payload);
    const subject = "New Flight Booking";
    sendMail(mailBody, subject);
    const response = await fetch.Post(
      "v1/booking/flight-orders",
      finalPayload,
      "application/json",
      token
    );

    if (response.status === 201) {
      const data = await response.json();
      return data;
    } else if (response?.status != 429 && response?.status != 401) {
      throw new Error("Something went wrong");
    }
  } catch (error) {
    throw error;
  }
};

// export const fetchFlightOffersByPost = async (
//   payload: flightSearchProps,
//   token: string
// ) => {
//   try {
//     let travelers = [];
//     let i = 1;
//     for (i; i <= payload?.adults; i++) {
//       travelers.push({
//         id: i.toString(),
//         travelerType: "ADULT",
//       });
//     }
//     for (let j = 1; j <= payload?.children; j++) {
//       travelers.push({
//         id: i.toString(),
//         travelerType: "CHILD",
//       });
//       i++;
//     }
//     for (let k = 1; k <= payload?.infants; k++) {
//       travelers.push({
//         id: i.toString(),
//         associatedAdultId: k.toString(),
//         travelerType: "HELD_INFANT",
//       });
//       i++;
//     }

//     const originDestinations: any[] = [
//       {
//         id: "1",
//         originLocationCode: payload?.origin,
//         destinationLocationCode: payload?.destination,
//         departureDateTimeRange: {
//           date: payload?.departureDate,
//         },
//       },
//     ];
//     if (payload?.returnDate && payload?.type == "round") {
//       originDestinations?.push({
//         id: "2",
//         originLocationCode: payload?.destination,
//         destinationLocationCode: payload?.origin,
//         arrivalDateTimeRange: {
//           date: payload?.returnDate,
//         },
//       });
//     }
//     let carrierRestrictions = {};
//     if (payload?.includedCarrierCodes?.length > 0) {
//       carrierRestrictions = {
//         carrierRestrictions: {
//           includedCarrierCodes: payload?.includedCarrierCodes,
//         },
//       };
//     }
//     const finalPayload = {
//       currencyCode: payload?.currencyCode || "CAD",
//       originDestinations: originDestinations,
//       travelers: travelers,
//       sources: payload?.source,
//       searchCriteria: {
//         maxFlightOffers: payload?.max || 250,
//         maxPrice: payload?.maxPrice,
//         pricingOptions: {
//           includedCheckedBagsOnly: payload?.includedCheckedBagsOnly,
//         },
//         flightFilters: {
//           maxFlightTime: payload?.maxFlightTime,
//           connectionRestriction: {
//             maxNumberOfConnections: payload?.nonStop
//               ? 0
//               : payload?.maxNumberOfConnections,
//             nonStopPreferred: payload?.nonStop,
//           },
//           ...carrierRestrictions,
//           cabinRestrictions: [
//             {
//               cabin: payload?.travelClass,
//               originDestinationIds: originDestinations?.map((item) => item?.id),
//             },
//           ],
//         },
//       },
//     };

//     const response = await fetch.Post(
//       controller + "flight-offers",
//       finalPayload,
//       "application/json",
//       token
//     );
//     if (response.status === 200) {
//       console.log(await response.json(), "response from flight offers");

//       const data = await response.json();
//       return data;
//     } else if (response.status === 201) {
//       const data = await response.json();
//       throw new Error(data);
//     } else if (response?.status != 429 && response?.status != 401) {
//       throw new Error("Something went wrong");
//     }
//   } catch (error) {
//     throw error;
//   }
// };
